import * as React from 'react';
import { observer } from 'mobx-react';
import { Instance } from 'mobx-state-tree';
import withTranslate, { WithTranslateProps } from '../common/WithTranslate';
import PharmacyMapComponent from '../common/PharmacyMapComponent';
import styled from '@emotion/styled';
import { Label, Button, ButtonGroup } from '@blueprintjs/core';
import { TLCode } from '../../common/enums';
import { PharmacyDetails } from '../../store/models/PharmacyDetails';
import { PharmacyStore } from '../../store';

const MapContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const Maps = styled.div`
  display: flex;
  height: 100%;
  flex-direction: row;
  justify-content: space-between;
  flex: 1;
`;

interface PharmacyMapPanelState {
  initialZoomCalculatedDay: boolean;
  initialZoomCalculatedNight: boolean;
  displayMode: string;
}

interface PharmacyMapPanelProps extends WithTranslateProps {
  pharmacyDetails: Instance<typeof PharmacyDetails>;
  PharmacyDetailedStore?: any;
  PharmacyStore?: any;
  GroupStore?: any;
}

@observer
class PharmacyMapPanel extends React.Component<PharmacyMapPanelProps, PharmacyMapPanelState> {
  state = {
    initialZoomCalculatedDay: false,
    initialZoomCalculatedNight: false,
    displayMode: 'std'
  } as PharmacyMapPanelState;

  fitBounds = (type: 'day' | 'night', map: google.maps.Map) => {
    if (
      (type === 'day' && !this.state.initialZoomCalculatedDay) ||
      (type === 'night' && !this.state.initialZoomCalculatedNight)
    ) {
      const { pharmacyDetails, PharmacyStore } = this.props;
      // @ts-ignore
      const bounds = new window.google.maps.LatLngBounds();
      if (pharmacyDetails.pharmacyNeighbors) {
        pharmacyDetails.pharmacyNeighbors
          .map((item) => {
            return PharmacyStore!.getById(item.neighborId);
          })
          .forEach(
            (d) =>
              // @ts-ignore
              bounds.extend(new window.google.maps.LatLng(d.latitude, d.longitude)),
            // @ts-ignore
          );
      } else {
        // @ts-ignore
        bounds.extend(new window.google.maps.LatLng(pharmacyDetails.latitude, pharmacyDetails.longitude));
      }
      if (type === 'day') {
        map.fitBounds(bounds);
        this.setState({ initialZoomCalculatedDay: true });
      } else {
        map.fitBounds(bounds);
        this.setState({ initialZoomCalculatedNight: true });
      }
    }
  };

  togglePairingAllowed = async (pharmacyNeighborId: number) => {
    const pn = this.props.pharmacyDetails.pharmacyNeighbors.find((n) => n.pharmacyNeighborId === pharmacyNeighborId);
    if (pn) {
      await this.props.PharmacyDetailedStore!.togglePairingAllowed(this.props.pharmacyDetails.pharmacyId, pn.neighborId);
    }
  };

  toggleExchangeAllowed = async (pharmacyNeighborId: number) => {
    const pn = this.props.pharmacyDetails.pharmacyNeighbors.find((n) => n.pharmacyNeighborId === pharmacyNeighborId);
    if (pn) {
      await this.props.PharmacyDetailedStore!.toggleExchangeAllowed(this.props.pharmacyDetails.pharmacyId, pn.neighborId);
    }
  };

  render() {
    const { PharmacyStore, pharmacyDetails, translate } = this.props;

    return (
      <div>
        <b>
          ({pharmacyDetails!.level})&nbsp;&nbsp;{pharmacyDetails!.apbNumber}&nbsp;-&nbsp;{pharmacyDetails!.name}
          &nbsp;-&nbsp;{pharmacyDetails!.address},&nbsp;
          {pharmacyDetails!.zipCode}&nbsp;
          {pharmacyDetails!.city}
        </b>

        <Maps>
          <MapContainer>
            {/* <Label
              style={{
                display: 'flex',
                justifyContent: 'center',
                fontWeight: 'bold',
              }}
            >
              {translate(TLCode.DUTYASSIGNMENT_DAY_ZONES)}
              {' ' + pharmacyDetails.minDistance! / 1000}
              {translate(TLCode.DUTYASSIGNMENT_DAY_ZONES2)}
              {pharmacyDetails.maxDistance! / 1000 + 'km'}
            </Label>
            <Label
              style={{
                display: 'flex',
                justifyContent: 'center',
                fontWeight: 'bold',
              }}
            >
              {translate(TLCode.DUTYASSIGNMENT_NIGHT_ZONES)}
              {' ' + pharmacyDetails.minDistance2! / 1000}
              {translate(TLCode.DUTYASSIGNMENT_NIGHT_ZONES2)}
              {pharmacyDetails.maxDistance2! / 1000 + 'km'}
            </Label> */}
            <br/>
            <ButtonGroup>
              <Button
                text={translate(TLCode.PHARMACIES_Standard)}
                onClick={() => this.setState({ displayMode: 'std'})}
                active={this.state.displayMode === 'std'}
              />
              <Button
                text={translate(TLCode.PHARMACIES_Pairing)}
                onClick={() => this.setState({ displayMode: 'co'})}
                active={this.state.displayMode === 'co'}
              />
              <Button
                text={translate(TLCode.PHARMACIES_Exchanges)}
                onClick={() => this.setState({ displayMode: 'ex'})}
                active={this.state.displayMode === 'ex'}
              />
            </ButtonGroup>
            <br/>
            <PharmacyMapComponent
              center={{ lat: Number(pharmacyDetails.latitude), lng: Number(pharmacyDetails.longitude) }}
              pharmacy={pharmacyDetails}
              neighbors={pharmacyDetails.pharmacyNeighbors
                .filter(
                  (elem) =>
                    elem.distance == null ||
                    pharmacyDetails.maxDistance == null ||
                    elem.distance! <= pharmacyDetails.maxDistance!,
                )
                .map((item) => {
                  var n = PharmacyStore!.getById(item.neighborId);
                  n.pairingAllowed = item.pairingAllowed;
                  n.exchangeAllowed = item.exchangeAllowed;
                  n.pharmacyNeighborId = item.pharmacyNeighborId;
                  return n
                })}
              onMapLoad={(map: google.maps.Map) => this.fitBounds('day', map)}
              displayMode={this.state.displayMode}
              togglePairingAllowed={(id) => this.togglePairingAllowed(id)}
              toggleExchangeAllowed={(id) => this.toggleExchangeAllowed(id)}
            />
          </MapContainer>
        </Maps>
      </div>
    );
  }
}

export default withTranslate(PharmacyMapPanel);
